import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid #ddd',
      padding: '2rem 1rem',
      marginTop: '4rem'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        textAlign: 'center'
      }}>
        {/* Social Media Links */}
        <div style={{
          marginBottom: '1.5rem',
          display: 'flex',
          justifyContent: 'center',
          gap: '1.5rem',
          flexWrap: 'wrap'
        }}>
          <a 
            href="https://twitter.com/studyhallxyz" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              color: '#333',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '0.6'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 448 512" fill="currentColor">
              <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"></path>
            </svg>
          </a>

          <a 
            href="https://www.instagram.com/studyhallxyz/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              color: '#333',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '0.6'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 448 512" fill="currentColor">
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
            </svg>
          </a>

          <a 
            href="https://www.youtube.com/@StudyHallFreelance" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Study Hall on YouTube"
            style={{
              display: 'inline-block',
              color: '#333',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '0.6'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 448 512" fill="currentColor">
              <path d="M384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM185.3 352.4V159.6L320 256 185.3 352.4z"></path>
            </svg>
          </a>

          <a 
            href="https://www.linkedin.com/company/study-hallxyz/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              color: '#333',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '0.6'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 448 512" fill="currentColor">
              <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
            </svg>
          </a>

          <a 
            href="https://www.facebook.com/profile.php?id=61552575038301" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              color: '#333',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '0.6'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 448 512" fill="currentColor">
              <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path>
            </svg>
          </a>
        </div>

        {/* Logo and Copyright */}
        <div>
          <div style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            letterSpacing: '0.1em',
            marginTop: '1rem',
            marginBottom: '0.5rem',
            color: '#333'
          }}>
            STUDY HALL
          </div>
          <p style={{
            fontSize: '0.875rem',
            color: '#999',
            margin: 0
          }}>
            Copyright © {new Date().getFullYear()} Study Hall
          </p>
        </div>
      </div>
    </footer>
  );
}

